import React, { Component } from 'react';
import PropTypes from 'prop-types';
import arrow from '../../../../../assets/images/arrow-right-b@3x.png';
import './index.scss';

export default class SliderCard extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      isShowLeftArrow: false,
      isShowRightArrow: false,
    };
    this.sliderContainer = React.createRef();
    this.onScrollHandle = this.onScrollHandle.bind(this);
    this.mouseDownHandler = this.mouseDownHandler.bind(this);
    this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
    this.mouseUpHandler = this.mouseUpHandler.bind(this);
    this.pos = { top: 0, left: 0, x: 0, y: 0 };
  }

  showArrow() {
    const ele = this.sliderContainer.current;
    if (!ele) {
      return;
    }
    if (ele.scrollLeft === 0) {
      if (ele.scrollWidth > ele.clientWidth) {
        this.setState({
          isShowLeftArrow: false,
          isShowRightArrow: true,
        });
      } else {
        this.setState({
          isShowLeftArrow: false,
          isShowRightArrow: false,
        });
      }
    } else if (ele.scrollLeft >= ele.scrollWidth - ele.clientWidth) {
      this.setState({
        isShowLeftArrow: true,
        isShowRightArrow: false,
      });
    } else {
      this.setState({
        isShowLeftArrow: true,
        isShowRightArrow: true,
      });
    }
  }

  mouseDownHandler(e) {
    const ele = this.sliderContainer.current;
    if (!ele) {
      return;
    }
    ele.style.cursor = 'grabbing';
    ele.style.userSelect = 'none';
    this.pos = {
      left: ele.scrollLeft,
      top: ele.scrollTop,
      // Get the current mouse position
      x: e.clientX,
      y: e.clientY,
    };
    document.addEventListener('mousemove', this.mouseMoveHandler);
    document.addEventListener('mouseup', this.mouseUpHandler);
  }

  mouseMoveHandler(e) {
    const ele = this.sliderContainer.current;
    if (!ele) {
      return;
    }

    // How far the mouse has been moved
    const dx = e.clientX - this.pos.x;
    const dy = e.clientY - this.pos.y;

    // Scroll the element
    ele.scrollTop = this.pos.top - dy;
    ele.scrollLeft = this.pos.left - dx;

    // show arrow
    this.showArrow();
  }

  mouseUpHandler() {
    const ele = this.sliderContainer.current;

    if (!ele) {
      return;
    }

    ele.style.cursor = 'grab';
    ele.style.removeProperty('user-select');

    document.removeEventListener('mousemove', this.mouseMoveHandler);
    document.removeEventListener('mouseup', this.mouseUpHandler);
  }

  onScrollHandle() {
    this.showArrow();
  }

  componentDidMount() {
    const ele = this.sliderContainer.current;
    if (!ele) {
      return;
    }
    ele.style.cursor = 'grab';
    setTimeout(() => {
      this.showArrow();
    }, 300);
    // Attach the handler
    ele.addEventListener('mousedown', this.mouseDownHandler);
  }

  render() {
    const { isShowLeftArrow, isShowRightArrow } = this.state;
    return (
      <div className="slider-container-wrap">
        <div
          className="slider-container"
          ref={this.sliderContainer}
          onScrollCapture={this.onScrollHandle}
        >
          {React.Children.map(this.props.children, (child) => {
            return <div>{child}</div>;
          })}
        </div>
        {isShowLeftArrow && (
          <div className="slider-container-left">
            <img src={arrow} alt="" />
          </div>
        )}
        {isShowRightArrow && (
          <div className="slider-container-right">
            <img src={arrow} alt="" />
          </div>
        )}
      </div>
    );
  }
}
